'use es6';

import { createReducer } from 'dashboard-lib/public/request/redux-request';
import { fetchTeamHierarchyActions } from 'dashboard-lib/public/team/team-hierarchy-action';
import { Map as ImmutableMap } from 'immutable';
export const teamHierarchyReducer = createReducer(fetchTeamHierarchyActions, ImmutableMap());